import TheraphyCards from 'src/components/cards/admin/therapy/therapyCards';

const Users = () => (
  <div className='flex flex-wrap mt-4'>
    <div className='w-full mb-12 px-4'>
      <TheraphyCards color='light' />
    </div>
  </div>
);

export default Users;
